/*  import React, { useEffect, useState } from "react";
import { IssueAPI, TaskUsersAPI, ProjectAPI } from "../api/apiClient";
import { useUI } from "../context/UIContext";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-hot-toast";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TaskUser } from "../types/taskuser";
import { ProjectUser } from "../types/ProjectUser";
//
//import { Issue } from "../types/issue";


export default function IssueDetails({ projectId, taskId }: { projectId: number, taskId: number }) {
  const [loading, setLoading] = useState(true);
  //change any to Issue | null
  const [issue, setIssue] = useState<any>(null);
  //task group add
  const [taskGroups, setTaskGroups] = useState<
  { taskGroupNo: number; taskGroupName: string }[]
>([]);


  const load = () => {
    setLoading(true);
    IssueAPI.getDetails(projectId, taskId)
      .then(setIssue)
      .catch(() => toast.error("Failed to load issue details"))
      .finally(() => setLoading(false));
  };

 // useEffect(load, [taskId]);
 useEffect(() => {
  if (!projectId || !taskId) return;
  load();
}, [projectId, taskId]);

  //task group add
  useEffect(() => {
  if (!projectId) return;

  ProjectAPI.getTaskGroups(projectId)
    .then(setTaskGroups)
    .catch(() => toast.error("Failed to load task groups"));
}, [projectId]);


  const handleUpdate = async (field: string, value: any) => {
    try {
    await IssueAPI.update(projectId, taskId, { [field]: value });
    toast.success("Updated!");
    load();
    } catch (err: any) {
    toast.error(err.message || "Update failed");
  }
  };

  const [participants, setParticipants] = useState<TaskUser[]>([]);
     useEffect(() => {
      TaskUsersAPI.list(taskId).then(setParticipants).catch(console.error);
    }, [taskId]); 
    const [projectUsers, setProjectUsers] = useState<ProjectUser[]>([]);
    const [newUser, setNewUser] = useState<number | "">("");
    const [role, setRole] = useState<string>("");
    useEffect(() => {
      TaskUsersAPI.list(taskId).then(setParticipants).catch(console.error);
      ProjectAPI.getUsers(projectId).then(setProjectUsers).catch(console.error);
    }, [taskId, projectId]);

    const addUser = async () => {
      if (!newUser) return;
      await TaskUsersAPI.assign(taskId, newUser, role);

      setNewUser("");
      setRole("");
      TaskUsersAPI.list(taskId).then(setParticipants);
    };

    const removeUser = async (userNo: number) => {
      await TaskUsersAPI.unassign(taskId, userNo);
      TaskUsersAPI.list(taskId).then(setParticipants);
    };

    const { user } = useAuth();
   
  const isAdmin = user?.userType?.toLowerCase() === "admin";

const canEdit = !!issue && (
  issue.taskOwner === user?.userNo ||
  issue.taskAssignee === user?.userNo ||
  isAdmin
);

  if (loading) return <div className="p-4">Loading...</div>;
 ;
 if (!issue) return null;



  return (

<div className="w-full h-full overflow-y-auto space-y-5 px-4 py-4 md:max-w-2xl">








   
    <textarea
  defaultValue={issue.title}
  placeholder="Enter task name..."
  onBlur={(e) => handleUpdate("title", e.target.value)}
  className="w-full text-2xl font-semibold border-b border-gray-300 focus:border-blue-500 focus:outline-none resize-none"
  rows={2}
/>


 
    <div className="space-y-1">
      <label className="text-sm font-medium text-gray-600">Description</label>
      <textarea
        defaultValue={issue.description}
        onBlur={(e) => handleUpdate("description", e.target.value)}
        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
        rows={4}
      />
    </div>

   
    <div className="space-y-1">
      <label className="text-sm font-medium text-gray-600">Assignee</label>
      <select
        value={issue.taskAssignee ?? ""}
        onChange={(e) => handleUpdate("taskAssignee", Number(e.target.value))}
        className="border rounded-md p-2 w-full"
        disabled={!(issue.taskOwner === user?.userNo)}
      >
        <option value="">— Select —</option>
        {participants.map((p) => (
          <option key={p.userNo} value={p.userNo}>
            {p.userName}
          </option>
        ))}
      </select>
    </div>

   
    <div className="space-y-1">
      <label className="text-sm font-medium text-gray-600">Status</label>
      <select
        defaultValue={issue.status}
        onChange={(e) => handleUpdate("status", e.target.value)}
        className="border rounded-md p-2 w-full"
        disabled={!canEdit}
      >
        <option>Open</option>
        <option>Closed</option>
      </select>
    </div>

   
<div className="space-y-1">
  <label className="text-sm font-medium text-gray-600">
    Task Group
  </label>
  <select
    value={issue.taskGroupNo ?? ""}
    onChange={(e) =>
      handleUpdate("taskGroupNo", Number(e.target.value))
    }
    className="border rounded-md p-2 w-full"
    disabled={!canEdit}
  >
    <option value="">— Select Task Group —</option>
    {taskGroups.map((g) => (
      <option key={g.taskGroupNo} value={g.taskGroupNo}>
        {g.taskGroupName}
      </option>
    ))}
  </select>
</div>

   
    <div className="space-y-1">
      <label className="text-sm font-medium text-gray-600">
        Progress — {issue.progressPercent ?? 0}%
      </label>
       <input
        type="range" 
        min="0"
        max="100"
        defaultValue={issue.progressPercent ?? 0}
        onMouseUp={(e) =>
          handleUpdate("progress", Number((e.target as HTMLInputElement).value))
        }
        className="w-full"
        disabled={!canEdit}
      /> 
     
   
<div className="space-y-1">
  <label className="text-sm font-medium text-gray-600">
    Next Reminder Date
  </label>
  <DatePicker
    selected={issue.nextReminderDate ? new Date(issue.nextReminderDate) : null}
    onChange={(d) => {
      if (!d) return;
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      handleUpdate("nextReminderDate", `${yyyy}-${mm}-${dd}`);
    }}
    dateFormat="dd-MMM-yyyy"
    className="border px-2 py-1 rounded-md w-full"
    disabled={!canEdit}
  />
</div>


<div className="space-y-1">
  <label className="text-sm font-medium text-gray-600">
    Overall Due Date
  </label>
  <DatePicker
    selected={issue.overallDueDate ? new Date(issue.overallDueDate) : null}
    onChange={(d) => {
      if (!d) return;
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      handleUpdate("overallDueDate", `${yyyy}-${mm}-${dd}`);
    }}
    dateFormat="dd-MMM-yyyy"
    className="border px-2 py-1 rounded-md w-full"
    disabled={!canEdit}
  />
</div>


<div className="space-y-1">
  <label className="text-sm font-medium text-gray-600">
    Next Action
  </label>

  <input
    defaultValue={issue.nextAction || ""}
    placeholder="Type next action and press Enter"
    className="w-full border px-2 py-2 rounded-md"
    disabled={!canEdit}
    onKeyDown={(e) => {
      if (e.key === "Enter") {
        const value = (e.target as HTMLInputElement).value;

        if (!value.trim()) return;

        handleUpdate("nextAction", value);

      
        (e.target as HTMLInputElement).value = "";
      }
    }}
  />
</div>

  
    <div className="space-y-1">
      <label className="text-sm font-medium text-gray-600">Subcontractor</label>
      <select
        value={issue.Subcontractor ?? ""}
        onChange={(e) => handleUpdate("Subcontractor", Number(e.target.value))}
        className="border rounded-md p-2 w-full"
        disabled={!canEdit}
      >
        <option value="">— Select —</option>
        {participants.map((p) => (
          <option key={p.userNo} value={p.userNo}>
            {p.userName}
          </option>
        ))}
      </select>
    </div>


    <div className="space-y-1">
      <label className="text-sm font-medium text-gray-600">Client</label>
      <select
        value={issue.Client ?? ""}
        onChange={(e) => handleUpdate("Client", Number(e.target.value))}
        className="border rounded-md p-2 w-full"
        disabled={!canEdit}
      >
        <option value="">— Select —</option>
        {participants.map((p) => (
          <option key={p.userNo} value={p.userNo}>
            {p.userName}
          </option>
        ))}
      </select>
    </div>
      
    <div className="border rounded p-4 bg-white">
      <h3 className="font-semibold mb-2">Participants</h3>

     
      {participants.length === 0 ? (
        <div className="text-sm text-gray-500">No participants yet</div>
      ) : (
        <ul className="space-y-2">
          {participants.map(p => (
            <li
              key={p.userNo}
              className="flex items-center justify-between bg-gray-100 px-3 py-1 rounded"
            >
              <span>{p.userName}{p.role ? ` (${p.role})` : ""}</span>
              <button
                className="text-red-500 text-sm hover:underline"
                disabled={!canEdit}
                onClick={() => removeUser(p.userNo)}
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
      )}

     
        <div className="flex flex-col gap-2 mt-3 md:flex-row">

        <select
          value={newUser}
          disabled={!canEdit}
          onChange={(e) => setNewUser(Number(e.target.value))}
         
          className="border rounded p-2 w-full md:flex-1"

        >
          <option value="">— Add participant —</option>
          {projectUsers
            .filter(u => !participants.some(p => p.userNo === u.userNo))
            .map(u => (
              <option key={u.userNo} value={u.userNo}>
                {u.userName}
              </option>
            ))}
        </select>

        <input
          placeholder="Role (optional)"
         
          className="border rounded px-2 py-1 w-full md:w-32"

          value={role}
          onChange={(e) => setRole(e.target.value)}
        />

        <button
          disabled={!newUser}
          onClick={addUser}
         
          className="px-4 py-2 bg-blue-600 text-white rounded w-full md:w-auto disabled:bg-gray-400"

        >
          Add
        </button>
      </div>
    </div>

  </div>
  
);

}
 

 */
import React, { useEffect, useState } from "react";
import { IssueAPI, TaskUsersAPI, ProjectAPI } from "../api/apiClient";
import { useUI } from "../context/UIContext";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-hot-toast";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TaskUser } from "../types/taskuser";
import { ProjectUser } from "../types/ProjectUser";
//
//import { Issue } from "../types/issue";


export default function IssueDetails({ projectId, taskId }: { projectId: number, taskId: number }) {
  const [loading, setLoading] = useState(true);
  //change any to Issue | null
  const [issue, setIssue] = useState<any>(null);
  //task group add
  const [taskGroups, setTaskGroups] = useState<
  { taskGroupNo: number; taskGroupName: string }[]
>([]);


  const load = () => {
    setLoading(true);
    IssueAPI.getDetails(projectId, taskId)
      .then(setIssue)
      .catch(() => toast.error("Failed to load issue details"))
      .finally(() => setLoading(false));
  };

 // useEffect(load, [taskId]);
 useEffect(() => {
  if (!projectId || !taskId) return;
  load();
}, [projectId, taskId]);

  //task group add
  useEffect(() => {
  if (!projectId) return;

  ProjectAPI.getTaskGroups(projectId)
    .then(setTaskGroups)
    .catch(() => toast.error("Failed to load task groups"));
}, [projectId]);


    const handleUpdate = async (field: string, value: any) => {
    try {
    await IssueAPI.update(projectId, taskId, { [field]: value });
    toast.success("Updated!");
    load();
    } catch (err: any) {
    toast.error(err.message || "Update failed");
  }
  }; 
  
 /* const handleUpdate = async (field: string, value: any) => {
  try {
    await IssueAPI.update(projectId, taskId, { [field]: value });

    setIssue((prev: any) => ({
      ...prev,
      [field]: value,

      ...(field === "progress"
        ? { progressPercent: value }
        : {}),
    }));

    toast.success("Updated!");
  } catch (err: any) {
    toast.error(err.message || "Update failed");
  }
}; */
  const [participants, setParticipants] = useState<TaskUser[]>([]);
   /*  useEffect(() => {
      TaskUsersAPI.list(taskId).then(setParticipants).catch(console.error);
    }, [taskId]); */
    const [projectUsers, setProjectUsers] = useState<ProjectUser[]>([]);
    const [newUser, setNewUser] = useState<number | "">("");
    const [role, setRole] = useState<string>("");
    useEffect(() => {
      TaskUsersAPI.list(taskId).then(setParticipants).catch(console.error);
      ProjectAPI.getUsers(projectId).then(setProjectUsers).catch(console.error);
    }, [taskId, projectId]);

    const addUser = async () => {
      if (!newUser) return;
      await TaskUsersAPI.assign(taskId, newUser, role);

      setNewUser("");
      setRole("");
      TaskUsersAPI.list(taskId).then(setParticipants);
    };

    const removeUser = async (userNo: number) => {
      await TaskUsersAPI.unassign(taskId, userNo);
      TaskUsersAPI.list(taskId).then(setParticipants);
    };

    const { user } = useAuth();
    /*const canEdit = !!issue && (
  issue.taskOwner === user?.userNo ||
  issue.taskAssignee === user?.userNo);*/
  const isAdmin = user?.userType?.toLowerCase() === "admin";

const canEdit = !!issue && (
  issue.taskOwner === user?.userNo ||
  issue.taskAssignee === user?.userNo ||
  isAdmin
);

  if (loading) return <div className="p-4">Loading...</div>;
  if (!issue) return <div className="p-4">Issue not found</div>;



  return (
 //<div className="max-w-2xl space-y-5 p-4 overflow-y-auto h-full">

//<div className="max-w-2xl w-full space-y-5 p-4">
  //<div className="w-full md:max-w-2xl h-full overflow-y-auto space-y-5 p-4">

//<div className="w-full md:max-w-2xl h-full overflow-y-auto space-y-5 p-4">
//<div className="w-full h-full overflow-y-auto space-y-5 px-0 py-4 md:p-4 md:max-w-2xl">
//<div className="w-full md:max-w-2xl flex-1 min-h-0 overflow-y-auto space-y-5 px-4 py-4">
<div className="w-full h-full overflow-y-auto space-y-5 px-4 py-4 md:max-w-2xl">








   {/* <input
      defaultValue={issue.title}
      onBlur={(e) => handleUpdate("title", e.target.value)}
      className="w-full text-2xl font-semibold border-b border-gray-300 focus:border-blue-500 focus:outline-none"
      placeholder="Enter task name..."
    />*/}

    <textarea
  defaultValue={issue.title}
  placeholder="Enter task name..."
  onBlur={(e) => handleUpdate("title", e.target.value)}
  className="w-full text-2xl font-semibold border-b border-gray-300 focus:border-blue-500 focus:outline-none resize-none"
  rows={2}
/>


    {/* Description */}
    <div className="space-y-1">
      <label className="text-sm font-medium text-gray-600">Description</label>
      <textarea
        defaultValue={issue.description}
        onBlur={(e) => handleUpdate("description", e.target.value)}
        className="w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
        rows={4}
      />
    </div>

    {/* Assignee */}
    {/* <div className="space-y-1">
      <label className="text-sm font-medium text-gray-600">Assignee</label>
      <select
        value={issue.taskAssignee ?? ""}
        onChange={(e) => handleUpdate("taskAssignee", Number(e.target.value))}
        className="border rounded-md p-2 w-full"
        disabled={!(issue.taskOwner === user?.userNo)}
      >
        <option value="">— Select —</option>
        {participants.map((p) => (
          <option key={p.userNo} value={p.userNo}>
            {p.userName}
          </option>
        ))}
      </select>
    </div> */}
    {/* Assignee */}
<div className="space-y-1">
  <label className="text-sm font-medium text-gray-600">
    Assignee
  </label>

  <select
    value={issue.taskAssignee ?? ""}
    onChange={(e) =>
      handleUpdate("taskAssignee", Number(e.target.value))
    }
    className="border rounded-md p-2 w-full"
    disabled={!isAdmin && issue.taskOwner !== user?.userNo}
  >
    <option value="">— Select Assignee —</option>

    {projectUsers.map((u) => (
      <option key={u.userNo} value={u.userNo}>
        {u.userName}
      </option>
    ))}
  </select>
</div>

    {/* Status */}
    <div className="space-y-1">
      <label className="text-sm font-medium text-gray-600">Status</label>
      <select
        defaultValue={issue.status}
        onChange={(e) => handleUpdate("status", e.target.value)}
        className="border rounded-md p-2 w-full"
        disabled={!canEdit}
      >
        <option>Open</option>
        <option>Closed</option>
      </select>
    </div>

    {/* task group add*/}
{/* Task Group */}
<div className="space-y-1">
  <label className="text-sm font-medium text-gray-600">
    Task Group
  </label>
  <select
    value={issue.taskGroupNo ?? ""}
    onChange={(e) =>
      handleUpdate("taskGroupNo", Number(e.target.value))
    }
    className="border rounded-md p-2 w-full"
    disabled={!canEdit}
  >
    <option value="">— Select Task Group —</option>
    {taskGroups.map((g) => (
      <option key={g.taskGroupNo} value={g.taskGroupNo}>
        {g.taskGroupName}
      </option>
    ))}
  </select>
</div>

    {/* Progress */}
      <div className="space-y-1">
      <label className="text-sm font-medium text-gray-600">
        Progress — {issue.progressPercent ?? 0}%
       </label>
      {/* <input
        type="range" 
        min="0"
        max="100"
        defaultValue={issue.progressPercent ?? 0}
        onMouseUp={(e) =>
          handleUpdate("progress", Number((e.target as HTMLInputElement).value))
        }
        className="w-full"
        disabled={!canEdit}
      />  */}
     {/* <input
  type="range"
  min="0"
  max="100"
  defaultValue={issue.progressPercent ?? 0}
  onChange={(e) =>
    handleUpdate("progress", Number(e.target.value))
  }
  className="w-full"
  disabled={!canEdit}
/> */}
<input
  type="range"
  min="0"
  max="100"
  defaultValue={issue.progressPercent ?? 0}
  onMouseUp={(e) =>
    handleUpdate(
      "progress",
      Number((e.target as HTMLInputElement).value)
    )
  }
  onTouchEnd={(e) =>
    handleUpdate(
      "progress",
      Number((e.target as HTMLInputElement).value)
    )
  }
  className="w-full"
  disabled={!canEdit}
/>
    </div>  

   
    

    {/* Due Date */}
    {/*<div className="space-y-1">
      <label className="text-sm font-medium text-gray-600">Due Date</label>
      <DatePicker
        selected={issue.dueDate ? new Date(issue.dueDate) : null}
        onChange={(d) => {
          if (!d) return;
          const yyyy = d.getFullYear(); 
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          const dd = String(d.getDate()).padStart(2, "0");
          handleUpdate("DueDate", `${yyyy}-${mm}-${dd}`);
        }}
        dateFormat="dd-MMM-yyyy"
        className="border px-2 py-1 rounded-md w-full"
        disabled={!canEdit} 
      />
    </div>*/}
    {/* Next Reminder Date */}
<div className="space-y-1">
  <label className="text-sm font-medium text-gray-600">
    Next Reminder Date
  </label>
  <DatePicker
    selected={issue.nextReminderDate ? new Date(issue.nextReminderDate) : null}
    onChange={(d) => {
      if (!d) return;
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      handleUpdate("nextReminderDate", `${yyyy}-${mm}-${dd}`);
    }}
    dateFormat="dd-MMM-yyyy"
    className="border px-2 py-1 rounded-md w-full"
    disabled={!canEdit}
  />
</div>

{/* Overall Due Date */}
<div className="space-y-1">
  <label className="text-sm font-medium text-gray-600">
    Overall Due Date
  </label>
  <DatePicker
    selected={issue.overallDueDate ? new Date(issue.overallDueDate) : null}
    onChange={(d) => {
      if (!d) return;
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      handleUpdate("overallDueDate", `${yyyy}-${mm}-${dd}`);
    }}
    dateFormat="dd-MMM-yyyy"
    className="border px-2 py-1 rounded-md w-full"
    disabled={!canEdit}
  />
</div>

{/* Next Action */}
<div className="space-y-1">
  <label className="text-sm font-medium text-gray-600">
    Next Action
  </label>

  <input
    defaultValue={issue.nextAction || ""}
    placeholder="Type next action and press Enter"
    className="w-full border px-2 py-2 rounded-md"
    disabled={!canEdit}
    onKeyDown={(e) => {
      if (e.key === "Enter") {
        const value = (e.target as HTMLInputElement).value;

        if (!value.trim()) return;

        handleUpdate("nextAction", value);

        // optional: clear input after sending
        (e.target as HTMLInputElement).value = "";
      }
    }}
  />
</div>

    {/* Subcontractor */}
    <div className="space-y-1">
      <label className="text-sm font-medium text-gray-600">Subcontractor</label>
      <select
        value={issue.Subcontractor ?? ""}
        onChange={(e) => handleUpdate("Subcontractor", Number(e.target.value))}
        className="border rounded-md p-2 w-full"
        disabled={!canEdit}
      >
        <option value="">— Select —</option>
        {participants.map((p) => (
          <option key={p.userNo} value={p.userNo}>
            {p.userName}
          </option>
        ))}
      </select>
    </div>

{/* Client */}
    <div className="space-y-1">
      <label className="text-sm font-medium text-gray-600">Client</label>
      <select
        value={issue.Client ?? ""}
        onChange={(e) => handleUpdate("Client", Number(e.target.value))}
        className="border rounded-md p-2 w-full"
        disabled={!canEdit}
      >
        <option value="">— Select —</option>
        {participants.map((p) => (
          <option key={p.userNo} value={p.userNo}>
            {p.userName}
          </option>
        ))}
      </select>
    </div>
        {/* Participants */}
    <div className="border rounded p-4 bg-white">
      <h3 className="font-semibold mb-2">Participants</h3>

      {/* Existing participants */}
      {participants.length === 0 ? (
        <div className="text-sm text-gray-500">No participants yet</div>
      ) : (
        <ul className="space-y-2">
          {participants.map(p => (
            <li
              key={p.userNo}
              className="flex items-center justify-between bg-gray-100 px-3 py-1 rounded"
            >
              <span>{p.userName}{p.role ? ` (${p.role})` : ""}</span>
              <button
                className="text-red-500 text-sm hover:underline"
                disabled={!canEdit}
                onClick={() => removeUser(p.userNo)}
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
      )}

      {/* Add participant */}
      {/*<div className="flex gap-2 mt-3">*/}
        <div className="flex flex-col gap-2 mt-3 md:flex-row">

        <select
          value={newUser}
          disabled={!canEdit}
          onChange={(e) => setNewUser(Number(e.target.value))}
          //className="border rounded p-2 flex-1"
          className="border rounded p-2 w-full md:flex-1"

        >
          <option value="">— Add participant —</option>
          {projectUsers
            .filter(u => !participants.some(p => p.userNo === u.userNo))
            .map(u => (
              <option key={u.userNo} value={u.userNo}>
                {u.userName}
              </option>
            ))}
        </select>

        <input
          placeholder="Role (optional)"
         // className="border rounded px-2 py-1 w-32"
          className="border rounded px-2 py-1 w-full md:w-32"

          value={role}
          onChange={(e) => setRole(e.target.value)}
        />

        <button
          disabled={!newUser}
          onClick={addUser}
          //className="px-4 py-2 bg-blue-600 text-white rounded disabled:bg-gray-400"
          className="px-4 py-2 bg-blue-600 text-white rounded w-full md:w-auto disabled:bg-gray-400"

        >
          Add
        </button>
      </div>
    </div>

  </div>
  
);

}
